import { MenuItem } from '@/shared/domain/MenuItem';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';
import HealthSubMenu from '@/shared/infrastructure/dataSource/menuPresets/HealthSubMenu';
import LearnSubMenu from '@/shared/infrastructure/dataSource/menuPresets/LearnSubMenu';

const { getBaseUrl } = useUrlHelper();

export const defaultPreset: Array < MenuItem > = [
  {
    label: 'common.healthInsurance',
    href: '',
    description: null,
    customClass: '',
    prefixImg: '',
    subMenu: HealthSubMenu
  },
  {
    label: 'common.dental',
    href: getBaseUrl('/supplemental-plans/dental'),
    description: null,
    customClass: '',
    prefixImg: '',
    subMenu: []
  },
  {
    label: 'common.vision',
    href: getBaseUrl('/supplemental-plans/vision-insurance'),
    description: null,
    customClass: '',
    prefixImg: '',
    subMenu: []
  },
  {
    label: 'common.learn',
    href: '',
    description: '',
    customClass: '',
    prefixImg: '',
    subMenu: LearnSubMenu
  }
];
